import { useContext, useEffect, useState, useRef } from 'react'
//import { createRoot } from 'react-dom/client';
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'
import moment from 'moment'
import { projectContext, loadingContext, urlValue, unfolder, encrypter, closeModalVw, openModalVw, groupBy, useTranslate, TranslationProvider } from '../../lib'
// import AsideBar from './AsideBar'

import '../../styles/settings.scss'
import '../../styles/swicthcss.css'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import CheckBox2 from '../../components/CheckBox2'
import Report from '../Report'
import ListReport from './ListReports'
import ReportCall from './ReportCall'
import ExcelJS from 'exceljs';
import ReactDOM from 'react-dom';
import jsPDF from 'jspdf';
import { toPng } from 'html-to-image';
import html2canvas from 'html2canvas';
import CallReportResumePDF from './CallReportResumePDF';
import CallReportResume from './CallReportResume';
import { Tooltip } from 'react-tooltip'

export default function GeneralReports() {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [project, setProject] = useState(null)
  const [clients, setClients] = useState([])
  const [modalRep, setModalRep] = useState(false)
  const [modalCallRep, setModalCallRep] = useState(false)
  const [call, setCall] = useState(null)
  const [isRenderingPDF, setIsRenderingPDF] = useState(false);
  const [pdfReportData, setPdfReportData] = useState(null);
  const [pagination, setPagination] = useState({ total_page: 1, page: 1, count: 0, limit: 100 })
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState({
    delete: false,
    new: false,
    edit: false,
  })
  const [refresh, setRefresh] = useState(false)
  const [selectedClient, setSelectedClient] = useState()
  const ref = useRef(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useContext(loadingContext)
  const [openTab, setOpenTab] = useState(1);
  const [call_list, setCallList] = useState([])
  const [call_list_excel, setCallListExcel] = useState([])
  const [campaings, setCampaings] = useState([])
  const [subCampaings, setSubCampaings] = useState([])
  const [pagingBusy, setPagingBusy] = useState(false);
  const [excludeShortConversations, setExcludeShortConversations] = useState(false)
  const [detailedImprovements, setDetailedImprovements] = useState(false)
  const [role, setRole] = useState(0)
  const campaingRef = useRef('')
  const subCampaingRef = useRef('')
  const search_ref = useRef(null);
  const search_user = useRef(null);
  const search_wave = useRef(null);
  const from = useRef();
  const to = useRef();

  const [firstReport, setFirstReport] = useState('')
  const [secondReport, setSecondReport] = useState('')
  const [thirdReport, setThirdReport] = useState('')
  const [forthReport, setForthReport] = useState('')
  const [fifthReport, setFifthReport] = useState('')
  const [sixthReport, setSixthReport] = useState('')
  const [seventhReport, setSeventhReport] = useState('')
  const tableRef = useRef(null);
  const { t } = useTranslate();
  const [filtersExpanded, setFiltersExpanded] = useState(false);
  const [hasPendingFilters, setHasPendingFilters] = useState(false);
  const [appliedFiltersSnapshot, setAppliedFiltersSnapshot] = useState(null);
  const [initialDateRange, setInitialDateRange] = useState({ from: '', to: '' });

  const [currentCampaign, setCurrentCampaign] = useState('All');
  const [currentSubCampaign, setCurrentSubCampaign] = useState('All');

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    setLoading(true)

    axios({
      method: 'get',
      url: `${urlValue}/studio/agent`,
      headers: {
        'access-token': token,
      },
    })
      .then(function (response) {
        setClients(response.data)
        setLoading(false)
      })
      .catch(function (error) {
        setLoading(false)
      })
  }, [refresh])

  const buildFiltersSnapshot = (overrides = {}) => {
    const base = {
      campaign: campaingRef.current?.value || 'All',
      sub_campaign: subCampaingRef.current?.value || 'All',
      search: search_ref.current?.value || '',
      userSearch: search_user.current?.value || '',
      wave: search_wave.current?.value || '',
      from: from.current?.value || initialDateRange.from || '',
      to: to.current?.value || initialDateRange.to || '',
      excludeShortConversations,
      detailedImprovements,
    };

    return { ...base, ...overrides };
  };

  const syncPendingFlag = (overrides = {}) => {
    const current = buildFiltersSnapshot(overrides);

    if (!appliedFiltersSnapshot) {
      setHasPendingFilters(true);
      return;
    }

    const same =
      JSON.stringify(current) === JSON.stringify(appliedFiltersSnapshot);

    setHasPendingFilters(!same);
  };


  const obtenerFechaActual = (firstday) => {
    const hoy = new Date();
    const año = hoy.getFullYear();
    let mes = hoy.getMonth() + 1;
    if (mes < 10) {
      mes = '0' + mes;
    }
    let dia = hoy.getDate();
    if (dia < 10) {
      dia = '0' + dia;
    }
    if (firstday) {
      dia = '01'
    }
    return `${año}-${mes}-${dia}`;
  }

  const updateQualification = (id, newQualification) => {
    setCallList(prev =>
      prev.map(el =>
        el.id === id
          ? {
            ...el,
            evaluations: newQualification
          }
          : el
      )
    );
  };

  const fetchCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/camp/campaingbyuser`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setCampaings(rest.data.data)
      }
      return rest;;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const fetchSubCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/project/camp/sub-campaingbyuser`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setSubCampaings(rest.data.data)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }

  const refreshCsrfToken = async () => {
    try {
      const csrfResp = await axios.get(`${urlValue}/csrf-token`, { withCredentials: true })
      const newCsrfToken = csrfResp?.data?.csrfToken
      if (newCsrfToken) {
        const userData = unfolder(localStorage.getItem('hashUser'), 'IANestingKey')
        userData.csrfToken = newCsrfToken
        const hashUser = encrypter(userData, 'IANestingKey')
        localStorage.setItem('hashUser', hashUser)
        return newCsrfToken
      }
      return null
    } catch (error) {
      console.error('Error refreshing CSRF token', error)
      return null
    }
  }

  const searchCall = async (page, exportExcel = false, retryWithNewToken = false) => {

    try {
      if (!exportExcel) setPagingBusy(true);
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
      let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

      if (retryWithNewToken) {
        const newToken = await refreshCsrfToken()
        if (newToken) {
          csrfToken = newToken
        }
      }

      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
      setLoading(true)

      const res = await axios.post(
        `${urlValue}/studio/project/reports/call`,
        {
          search: search_ref.current?.value || '',
          pagination: { page: page.page ?? page, limit: page.limit ?? pagination.limit },
          user_id: id,
          initialDate: moment(from.current.value).format('YYYY-MM-DD') + ' 00:00:00',
          finishDate: moment(to.current.value).format('YYYY-MM-DD') + ' 23:59:59',
          userSearch: search_user.current.value,
          campaign: campaingRef.current.value === 'All' ? '' : campaingRef.current.value,
          sub_campaign: subCampaingRef.current.value === 'All' ? '' : subCampaingRef.current.value,
          wave: search_wave?.current?.value || '',
          exclude_short_conversation: excludeShortConversations,
          exportExcel: exportExcel
        },
        {
          headers: {
            'access-token': token,
            user: id,
            'X-CSRF-Token': csrfToken
          },
          withCredentials: true,
        })

      if (res.status === 200) {
        if (exportExcel) {
          setCallListExcel(res.data?.data || [])
        }
        else {
          setCallList(prev => (res.data?.data || []));

          setPagination(prev => {
            const limit = Number(page.limit ?? prev.limit) || Number(prev.limit) || 100;
            const count = Number(res.data.count) || 0;
            const backendTotal = Number(res.data.total_page);
            const computedTotal = Math.max(1, Math.ceil(count / limit));
            const total_page = (backendTotal && backendTotal > 0) ? backendTotal : computedTotal;

            return {
              ...prev,
              page: Number(page.page ?? 1) || 1,
              total_page,
              count,
              limit
            };
          });
        }
      }
      setLoading(false)
    } catch (error) {
      if (error.response?.status === 403 && !retryWithNewToken) {
        console.log('CSRF token expired, refreshing and retrying...')
        return searchCall(page, exportExcel, true)
      }
      setLoading(false)
    } finally {
      if (!exportExcel) setPagingBusy(false);
    }

  }

  useEffect(() => {
    setRole(unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').role)

    const initFrom = obtenerFechaActual(true);
    const initTo = obtenerFechaActual(false);

    if (from.current) from.current.value = initFrom;
    if (to.current) to.current.value = initTo;

    setInitialDateRange({ from: initFrom, to: initTo });

    updateDateBounds();
    fetchCampaing();
    fetchSubCampaing();

    // Snapshot inicial de filtros aplicados (estado “sin cambios pendientes”)
    const initialSnapshot = {
      campaign: 'All',
      sub_campaign: 'All',
      search: '',
      userSearch: '',
      wave: '',
      from: initFrom,
      to: initTo,
      excludeShortConversations: false,
      detailedImprovements: false,
    };

    setAppliedFiltersSnapshot(initialSnapshot);
    setHasPendingFilters(false);
  }, [])

  const [projects, setProjects] = useState([])
  const fecthProjects = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    axios({
      method: 'get',
      // url: 'http://localhost:8080/studio/project',
      url: `${urlValue}/studio/client/projects-user/${id}`,
      // url: `${urlValue}/studio/project/category/outbound`,
      headers: {
        'access-token': token,
        user: id
      },
    })
      .then(function (response) {

        // setAnswers(response.data)
        getProjects(response.data);
        //setLoading(false);
      })
      .catch(function (error) {
        console.log(error)
        setLoading(false)
      })
  }


  const getProjects = async asignedProjects => {
    // setSelectedProject(selectedProject)
    //setProjects([])
    setLoading(true)
    //let proj = [];
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    const reqs = asignedProjects.map(p =>
      axios.get(`${urlValue}/studio/project/${p.project}`, { headers: { 'access-token': token, user: id } })
    );
    const res = await Promise.all(reqs);

    setProjects(res.map(r => r.data));

    setLoading(false)
  }


  const openModalRep = (p) => {
    setProject(p)
    openModalVw("#repgeneral-modal", () => setModalRep(true))
  }
  const openModalCallRep = (data) => {
    localStorage.setItem('report_project_selected', JSON.stringify(data));
    setCall(data)
    setTimeout(() => {
      openModalVw("#reportcall-modal", () => setModalCallRep(true))
    }, 500)
  }

  const goToPage = (p) => {
    setPagination(prev => {

      if (pagingBusy) return prev;

      const total = Number(prev.total_page) || 1;
      const current = Number(prev.page) || 1;

      const target = Math.max(1, Math.min(Number(p) || 1, total));

      if (target === current) return prev;

      const next = { ...prev, page: target };
      const term = search_ref.current?.value || '';

      searchCall({ page: target, limit: next.limit });

      return next;
    });
  };

  // useEffect(() => {
  //   const el = document.querySelector('#panel-infinity');
  //   if (!el) return;

  //   let ticking = false;
  //   const onScroll = () => {
  //     if (ticking) return;
  //     ticking = true;
  //     requestAnimationFrame(() => {
  //       handleScroll(el);
  //       ticking = false;
  //     });
  //   };

  //   el.addEventListener('scroll', onScroll);
  //   return () => el.removeEventListener('scroll', onScroll);
  // }, []);

  const goPrev = () => {
    if (pagingBusy) return;
    goToPage((pagination.page || 1) - 1);
  };

  const goNext = () => {
    if (pagingBusy) return;
    goToPage((pagination.page || 1) + 1);
  };

  const generateExcel = () => {
    let dataExpor = [];

    if (call_list_excel.length > 0) {
      for (let i = 0; i < call_list_excel.length; i++) {
        const evalObj = call_list_excel[i].evaluations || {};

        const proofread = (typeof evalObj.proofread === 'number')
          ? evalObj.proofread.toFixed(2)
          : '';

        const listproofread = Array.isArray(evalObj.listproofread)
          ? evalObj.listproofread
            .map(item => `${item.user} (score: ${item.score}) → ${item.correctPhrase}`)
            .join(' | ')
          : '';

        let sentiment = ''
        const polarityCount = { NEU: 0, POS: 0, NEG: 0 };
        let scoreSum = 0;
        let averageScore = '0.00'
        if (Array.isArray(evalObj.sentiment)) {

          sentiment = evalObj.sentiment
            .map(item => `User: "${item.user.trim()}", Polarity: ${item.polarity}`)
            .join(' | ');

          evalObj.sentiment.forEach(item => {
            const polarity = item.polarity?.toUpperCase();
            if (polarityCount.hasOwnProperty(polarity)) {
              polarityCount[polarity]++;
              // Asignar puntaje según polaridad
              if (polarity === 'POS') scoreSum += 1;
              else if (polarity === 'NEU') scoreSum += 0.5;
              // NEG suma 0, así que no hace falta sumar
            }
          });

          // Paso 4: Calcular promedio
          const total = evalObj.sentiment.length;
          averageScore = total > 0 ? (scoreSum / total).toFixed(2) : '0%';
        }

        let assesmentHits = [];
        if (evalObj.assesment) {
          for (let key in evalObj.assesment) {
            const section = evalObj.assesment[key];
            if (section.hits && Array.isArray(section.hits)) {
              assesmentHits = assesmentHits.concat(
                section.hits.map(hit => `${hit.intent}: ${hit.reason}`)
              );
            }
          }
        }
        assesmentHits = assesmentHits.join(' | ');

        let assesmentImprovements = [];
        if (evalObj.assesment) {
          for (let key in evalObj.assesment) {
            const section = evalObj.assesment[key];
            if (section.improvements.length > 0 && Array.isArray(section.improvements)) {
              assesmentImprovements = assesmentImprovements.concat(
                section.improvements.map(improvement => {
                  if (typeof improvement === 'string') return improvement;
                  const intent = improvement?.intent || '';
                  const reason = improvement?.reason || '';
                  if (intent && reason) return `${intent}: ${reason}`;
                  return intent || reason || JSON.stringify(improvement);
                })
              );
            }
          }
        }

        const baseData = {
          id: call_list_excel[i].id,
          bms_id: call_list_excel[i].bms_id || '',
          user: call_list_excel[i].bussiness_key,
          campaign: call_list_excel[i].campaign,
          sub_campaign: call_list_excel[i].sub_campaign,
          project_name: call_list_excel[i].project_name,
          date: call_list_excel[i].created_date,
          duration_call: call_list_excel[i].time_call,
          attempts: call_list_excel[i].attempts,
          score: evalObj?.qualification != null ? (isNaN(parseFloat(evalObj.qualification)) ? null : parseFloat(evalObj.qualification)) : null,
          proofread: proofread,
          listproofread: listproofread,
          conversation: evalObj.sentiment,
          sentiment: sentiment,
          assesmentHits: assesmentHits,
          num_time_hold: evalObj?.time_hold || 0,
          time_hold_second: evalObj?.second_hold || 0,
          sentimentPolarity: polarityCount,
          sentimentScore: averageScore
        };

        if (detailedImprovements && assesmentImprovements.length > 0) {
          assesmentImprovements.forEach(improvementText => {
            dataExpor.push({
              ...baseData,
              assesmentImprovements: improvementText
            });
          });
        } else {
          dataExpor.push({
            ...baseData,
            assesmentImprovements: assesmentImprovements.join(' | ')
          });
        }
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Datos');

      // Definición de columnas con la división de la información
      worksheet.columns = [
        { header: 'ID', key: 'id', width: 10 },
        { header: 'BMS ID', key: 'bms_id', width: 20 },
        { header: 'User', key: 'user', width: 20 },
        { header: 'Campaign', key: 'campaign', width: 30 },
        { header: 'Sub Campaign', key: 'sub_campaign', width: 30 },
        { header: 'Project Name', key: 'project_name', width: 30 },
        { header: 'Date', key: 'date', width: 20 },
        { header: 'Duration Call', key: 'duration_call', width: 15 },
        { header: 'Attempts', key: 'attempts', width: 10 },
        { header: 'Score', key: 'score', width: 10 },
        { header: 'Proofread', key: 'proofread', width: 10 },
        { header: 'List Proofread', key: 'listproofread', width: 40 },
        { header: 'Conversation', key: 'conversation', width: 40 },
        { header: 'Sentiment', key: 'sentiment', width: 40 },
        { header: 'Sentiment Polarity', key: 'sentimentPolarity', width: 40 },
        { header: 'Sentiment Score', key: 'sentimentScore', width: 40 },
        { header: 'Assesment Hits', key: 'assesmentHits', width: 60 },
        { header: 'Assesment Improvements', key: 'assesmentImprovements', width: 40 },
        { header: 'Num Time Hold', key: 'num_time_hold', width: 15 },
        { header: 'Time Hold Second', key: 'time_hold_second', width: 20 }
      ];

      // Se agregan las filas al worksheet
      dataExpor.forEach(data => {
        const row = worksheet.addRow(data);
        const scoreCell = row.getCell('score');
        if (scoreCell.value != null) {
          scoreCell.numFmt = '0.0%';
        }
      });

      // Se genera el archivo Excel y se dispara la descarga
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'projects_reports.xlsx';
        link.click();
      }).catch((err) => console.error('Error writing Excel file:', err));
    }
  }

  const generateEvaluations = async () => {
    let ok = true
    if (moment(from.current.value).format('YYYY-MM-DD') !== moment(to.current.value).format('YYYY-MM-DD')) {
      alert(t('alerts.validateDate'));
      ok = false
    }
    else if (subCampaingRef.current.value === 'All') {
      alert(t('alerts.validateSubCampaign'));
      ok = false
    }

    if (ok) {
      const filtrados = call_list.filter(item => item.evaluations === null).map(item => item.id);

      try {
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
        setLoading(true)

        const res = await axios.post(
          `${urlValue}/generate-evaluation`,
          {
            ids: filtrados
          },
          {
            headers: {
              'access-token': token,
              'X-CSRF-Token': csrfToken
            },
            withCredentials: true,
          })

        if (res.status === 200) {
          searchCall({ page: 1, limit: 100 })
        }
        setLoading(false)
      } catch (error) {
        setLoading(false)
      }
    }
  }

  const exportToExcelN = async (filename = 'export.xlsx', sheetName = 'Sheet1') => {
    await searchCall({ total_page: 0, page: 1, count: 0, limit: 100000 }, true);
  }

  useEffect(() => {
    if (call_list_excel.length > 0) {
      generateExcel();
    }
  }, [call_list_excel]);

  const downloadReportPDF = async (data) => {
    setLoading(true);
    setPdfReportData(data);
    setIsRenderingPDF(true);

    setTimeout(async () => {
      const container = document.getElementById('report-pdf-container');

      if (!container) {
        console.error("The container 'report-pdf-container' not found.");
        setLoading(false);
        setIsRenderingPDF(false);
        setPdfReportData(null);
        return;
      }

      let isLoading = true;
      const onLoadComplete = () => {
        isLoading = false;
      };

      const waitForLoad = async () => {
        while (isLoading) {
          await new Promise(resolve => setTimeout(resolve, 100));
          isLoading = false;
        }
      };

      try {
        await Promise.race([
          waitForLoad(),
          new Promise((_, reject) => setTimeout(() => reject(new Error('PDF generation timed out')), 10000))
        ]);

        // =================================================================
        // SOLUCIÓN COMPATIBLE CON TRUSTED TYPES (html-to-image)
        // =================================================================
        toPng(container, {
          quality: 0.95,
          backgroundColor: '#ffffff', // Asegura fondo blanco si hay transparencias
          style: {
            display: 'block' // Asegura que se renderice correctamente en la captura
          }
        })
          .then((imgData) => {
            const pdf = new jsPDF('p', 'mm', 'a4');
            const imgWidth = 210; // Ancho A4 en mm
            const pageHeight = 295; // Alto A4 en mm

            // Creamos una imagen temporal en memoria para calcular las proporciones reales del canvas generado
            const img = new Image();
            img.src = imgData;
            img.onload = () => {
              const imgHeight = img.height * imgWidth / img.width;
              let heightLeft = imgHeight;
              let position = 0;

              // Inyección de la primera página
              pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
              heightLeft -= pageHeight;

              // Páginas subsiguientes si el reporte es largo (Mantiene tu lógica original)
              while (heightLeft >= 0) {
                position -= pageHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
              }

              let name = 'call_report.pdf';
              if (data.id && data.ntUser) {
                name = `call_report_${data.ntUser}_${data.id}.pdf`;
              }
              pdf.save(name);

              // Limpieza de estados de React
              setIsRenderingPDF(false);
              setPdfReportData(null);
              setLoading(false);
            };
          })
          .catch((renderError) => {
            console.error('Error rendering image with html-to-image:', renderError);
            alert(t('alerts.pdfError'));
            setIsRenderingPDF(false);
            setPdfReportData(null);
            setLoading(false);
          });

      } catch (error) {
        console.error('Error in PDF generation process:', error);
        alert(t('alerts.pdfError'));
        setIsRenderingPDF(false);
        setPdfReportData(null);
        setLoading(false);
      }
    }, 1200);
  };

  const openDashboardModal = () => {
    const userId = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

    const dashboardData = {
      id: userId,
      project_name: "General Dashboard",
      session_code: "dashboard-session",
      bussiness_key: "dashboard",
      project: null,
      time_call: "00:00:00",
      time_call_seconds: 0,
      AmountTimeHold: 0,
      TimeSecondHold: 0,
      hang_call: false,
      channel: "dashboard",
      percentage_affectation: 0,
      created_date: new Date().toISOString(),
      evaluations: null
    };

    localStorage.setItem('report_project_selected', JSON.stringify(dashboardData));
    setCall(dashboardData);

    setTimeout(() => {
      openModalVw("#reportcall-modal", () => setModalCallRep(true));
    }, 500);
  };

  // Devuelve true si la diferencia de años es <= 1 (por número de año, no días)
  const isRangeWithinOneYear = (fromStr, toStr) => {
    if (!fromStr || !toStr) return true;
    const fy = new Date(fromStr).getFullYear();
    const ty = new Date(toStr).getFullYear();
    return (ty - fy) <= 1;
  };

  // Límites visuales de los inputs para guiar la selección
  const updateDateBounds = () => {
    const fromEl = from.current;
    const toEl = to.current;
    if (!fromEl || !toEl) return;

    const fv = fromEl.value;
    const tv = toEl.value;

    fromEl.removeAttribute('min');
    fromEl.removeAttribute('max');
    toEl.removeAttribute('min');
    toEl.removeAttribute('max');

    if (fv) {
      toEl.min = fv;
    }
  };

  // Corrige el rango si el usuario se sale de la regla y devuelve true si todo OK
  const enforceOneYearRule = (changed) => {
    const fromEl = from.current;
    const toEl = to.current;
    if (!fromEl || !toEl) return true;

    let fv = fromEl.value;
    let tv = toEl.value;
    if (!fv || !tv) { updateDateBounds(); return true; }

    if (isRangeWithinOneYear(fv, tv)) { updateDateBounds(); return true; }

    const fy = new Date(fv).getFullYear();
    const ty = new Date(tv).getFullYear();

    if (changed === 'from') {
      const newTo = `${fy + 1}-12-31`;
      toEl.value = new Date(tv) < new Date(fv) ? fv : newTo;
    } else {
      const newFrom = `${ty - 1}-01-01`;
      fromEl.value = new Date(fv) > new Date(tv) ? tv : newFrom;
    }

    updateDateBounds();
    return true;
  };

  const handleApplyFilters = () => {
    const current = buildFiltersSnapshot();
    setAppliedFiltersSnapshot(current);
    setHasPendingFilters(false);
    searchCall({ page: 1, limit: 100 });
    setFiltersExpanded(false);
  };

  const handleClearSingleFilter = (key) => {

    if (key === 'campaign' && campaingRef.current) {
      campaingRef.current.value = 'All';
      setCurrentCampaign('All');
    }

    if (key === 'sub_campaign' && subCampaingRef.current) {
      subCampaingRef.current.value = 'All';
      setCurrentSubCampaign('All');
    }

    if (key === 'search' && search_ref.current) {
      search_ref.current.value = '';
    }

    if (key === 'userSearch' && search_user.current) {
      search_user.current.value = '';
    }

    if (key === 'wave' && search_wave.current) {
      search_wave.current.value = '';
    }

    if (key === 'from' && from.current) {
      from.current.value = initialDateRange.from;
    }

    if (key === 'to' && to.current) {
      to.current.value = initialDateRange.to;
    }

    // Checkboxes
    if (key === 'excludeShortConversations') {
      setExcludeShortConversations(false);
    }

    if (key === 'detailedImprovements') {
      setDetailedImprovements(false);
    }

    syncPendingFlag({});

    setFiltersExpanded(prev => prev);
  };

  const handleClearAllFilters = () => {
    if (campaingRef.current) campaingRef.current.value = 'All';
    if (subCampaingRef.current) subCampaingRef.current.value = 'All';

    setCurrentCampaign('All');
    setCurrentSubCampaign('All');

    if (search_ref.current) search_ref.current.value = '';
    if (search_user.current) search_user.current.value = '';
    if (search_wave.current) search_wave.current.value = '';

    if (from.current && initialDateRange.from) {
      from.current.value = initialDateRange.from;
    }
    if (to.current && initialDateRange.to) {
      to.current.value = initialDateRange.to;
    }

    setExcludeShortConversations(false);
    setDetailedImprovements(false);

    const current = {
      campaign: 'All',
      sub_campaign: 'All',
      search: '',
      userSearch: '',
      wave: '',
      from: initialDateRange.from,
      to: initialDateRange.to,
      excludeShortConversations: false,
      detailedImprovements: false,
    };

    if (!appliedFiltersSnapshot) {
      setHasPendingFilters(true);
    } else {
      setHasPendingFilters(
        JSON.stringify(current) !== JSON.stringify(appliedFiltersSnapshot),
      );
    }
  };

  return (
    <>
      <div>

        <section className="container-answers general-container" id="container">
          <div className="row_primary">
            <div className="con_title_bar">
              <TitleBar />
            </div>
            <div className="con_header">
              <div className="header">
                <div className="title d-flex flex-row align-items-center justify-content-between w-100">
                  <div className="intents">
                    <div className="project-name-container">
                      <div className="icon"></div>
                    </div>
                    <div>
                      <h1 style={{ color: "#0087ff", fontWeight: "bold" }}>{t('menu.reports')}</h1>
                    </div>
                  </div>
                  <button onClick={() => openDashboardModal()} className='buttonH mb-2'>
                    Dashboard
                  </button>
                </div>
              </div>
            </div>

            {/* BLOQUE DE FILTROS MODERNO COMPLETO */}
            <div
              className="flex w-100 mt-2"
              style={{
                backgroundColor: "#F7F7F7",
                marginTop: 0,
                padding: 7,
                flexDirection: "column",
                borderRadius: "25px 25px 0 0",
                gap: 10,
              }}
            >

              {/* HEADER DE FILTROS */}
              <div
                className="filters-header"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 4,
                }}
              >

                {/* TÍTULO + ICONO PLACEHOLDER */}
                <div onClick={() => setFiltersExpanded((prev) => !prev)}
                  style={{ display: "flex", flexDirection: 'row', alignItems: "center", justifyContent: 'center', cursor: 'pointer' }}>
                  <div className='p-1'
                    style={{
                      width: 30, height: 28, borderRadius: '50%', backgroundColor: 'white', border: '1px solid #e9e9e9',
                      display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'
                    }}
                  >
                    <img src='/icons/Filters.png' width={15} height={15} />
                  </div>

                  <span
                    className="label-report ml-2"
                    style={{ fontWeight: 600, color: "#646464ff", fontSize: 14, whiteSpace: 'nowrap' }}
                  >
                    {t("common.searchFilters") || "Search filters"}
                  </span>
                </div>

                {/* EXPORT EXCEL + CLEAR ALL + BOTÓN COLAPSAR */}
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>

                  <button
                    type="button" style={{ backgroundColor: 'white', borderRadius: '50%', padding: 5 }}
                    onClick={() => exportToExcelN("table-report", "excel-data")}
                  >
                    <img
                      src="/icons/download-icon.png"
                      style={{ width: 15 }}
                      alt=""
                    />
                  </button>

                  <button
                    type="button"
                    style={{
                      border: "none",
                      background: "transparent",
                      fontSize: 12,
                      color: "#0087FF",
                      cursor: "pointer",
                    }}
                    onClick={handleClearAllFilters}
                  >
                    {t("common.clearAllFilters") || "Clear all"}
                  </button>

                  {/* BOTÓN FILTER */}
                  <button
                    className="create btn-primary btn-bottom btn-bottom-create"
                    style={{
                      backgroundColor: "#0087FF",
                      display: "flex",
                      alignItems: "center",
                      padding: "6px 18px",
                    }}
                    onClick={handleApplyFilters}
                  >
                    {hasPendingFilters && (
                      <span
                        style={{
                          width: 13,
                          height: 13,
                          borderRadius: "50%",
                          backgroundColor: "#FF4D4F",
                          color: "#FFF",
                          fontSize: 12,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        !
                      </span>
                    )}
                    <span className='ml-2'>{t("common.filter") || "Filter"}</span>
                  </button>

                  {/* COLAPSAR / EXPANDIR */}
                  <button
                    type="button"
                    onClick={() => setFiltersExpanded((prev) => !prev)}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 4,
                      cursor: "pointer",
                      borderRadius: 999,
                    }}
                  >
                    {filtersExpanded ? (
                      /* flechas hacia arriba */
                      <svg width="20" height="20" viewBox="0 0 16 16">
                        <path
                          d="M4 9l4-4 4 4"
                          stroke="#9E9E9E"
                          strokeWidth="1.5"
                          fill="none"
                          strokeLinecap="round"
                        />
                        <path
                          d="M4 13l4-4 4 4"
                          stroke="#9E9E9E"
                          strokeWidth="1.5"
                          fill="none"
                          strokeLinecap="round"
                        />
                      </svg>
                    ) : (
                      /* flechas hacia abajo */
                      <svg width="20" height="20" viewBox="0 0 16 16">
                        <path
                          d="M4 7l4 4 4-4"
                          stroke="#9E9E9E"
                          strokeWidth="1.5"
                          fill="none"
                          strokeLinecap="round"
                        />
                        <path
                          d="M4 3l4 4 4-4"
                          stroke="#9E9E9E"
                          strokeWidth="1.5"
                          fill="none"
                          strokeLinecap="round"
                        />
                      </svg>
                    )}
                  </button>
                </div>

              </div>

              {/* CHIPS DE FILTROS ACTIVOS */}
              {!filtersExpanded && (
                <div className='w-100'
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 5,
                    marginBottom: 6,
                  }}
                >
                  {/* CHIPS */}
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 6,
                    }}
                  >
                    {(() => {
                      const chips = [];
                      const campaignVal = campaingRef.current?.value;
                      const subVal = subCampaingRef.current?.value;
                      const searchVal = search_ref.current?.value;
                      const userVal = search_user.current?.value;
                      const waveVal = search_wave.current?.value;
                      const fromVal = from.current?.value;
                      const toVal = to.current?.value;

                      if (campaignVal && campaignVal !== "All")
                        chips.push({ key: "campaign", label: `${t("common.campaign")}: ${campaignVal}` });

                      if (subVal && subVal !== "All")
                        chips.push({ key: "sub_campaign", label: `${t("common.subCampaign")}: ${subVal}` });

                      if (searchVal)
                        chips.push({ key: "search", label: `${t("menu.searchProject")}: ${searchVal}` });

                      if (userVal)
                        chips.push({ key: "userSearch", label: `${t("menu.searchUser")}: ${userVal}` });

                      if (waveVal)
                        chips.push({ key: "wave", label: `${t("menu.searchWave")}: ${waveVal}` });

                      if (fromVal || toVal)
                        chips.push({
                          key: "dateRange",
                          label: `${t("common.from")}: ${fromVal || "–"} | ${t("common.to")}: ${toVal || "–"}`,
                        });

                      if (excludeShortConversations)
                        chips.push({ key: "excludeShortConversations", label: t("common.excludeShortCalls") });

                      if (detailedImprovements)
                        chips.push({ key: "detailedImprovements", label: t("common.detailedImprovements") });

                      return chips.map((chip) => (
                        <div
                          key={chip.key}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            padding: "3px 8px",
                            borderRadius: 999,
                            backgroundColor: "#FFFFFF",
                            border: "1px solid #E0E0E0",
                            fontSize: 11,
                            color: "#575756",
                          }}
                        >
                          {chip.label}
                          <button
                            onClick={() =>
                              chip.key === "dateRange"
                                ? (handleClearSingleFilter("from"), handleClearSingleFilter("to"))
                                : handleClearSingleFilter(chip.key)
                            }
                            style={{ background: "transparent", border: "none", cursor: "pointer", marginLeft: 6 }}
                          >
                            <svg width="10" height="10" viewBox="0 0 10 10">
                              <path
                                d="M2 2l6 6M8 2L2 8"
                                stroke="#999"
                                strokeWidth="1.4"
                                strokeLinecap="round"
                              />
                            </svg>
                          </button>
                        </div>
                      ));
                    })()}
                  </div>

                </div>
              )}

              {/* BLOQUE COLAPSABLE */}
              <div
                className="filters-body w-100"
                style={{
                  display: filtersExpanded ? "flex" : "none",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  alignItems: "center",
                }}
              >
                <div className='mr-2'
                  style={{
                    border: "1px solid #e1e1e1",
                    borderRadius: 10,
                    maxWidth: 281,
                    paddingBottom: 10,
                  }}>
                  {/* == CAMPAIGN == */}
                  <div
                    className="filter-reports ml-0 bg-white d-flex flex-row align-items-center justify-space-between"
                    style={{
                      backgroundColor: "#F7F7F7",
                      width: 200,
                      height: 30,
                      margin: 10,
                    }}
                  >
                    <label className="mr-2">{t("common.campaign")}: </label>
                    <div className="select" style={{ flexGrow: 2 }}>
                      <select
                        ref={campaingRef}
                        className="select-nesting select-report"
                        style={{ flexGrow: 2, fontSize: 12, backgroundPositionX: "98%", width: 184 }}
                        onChange={(e) => {
                          setCurrentCampaign(e.target.value);
                          syncPendingFlag();
                        }}
                      >
                        <option value="All">{t("common.all")}</option>
                        {campaings.map((item, i) => (
                          <option key={i} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* == SUB-CAMPAIGN == */}
                  <div
                    className="filter-reports ml-3 bg-white d-flex flex-row align-items-center justify-space-between"
                    style={{
                      backgroundColor: "#F7F7F7",
                      width: 200,
                      height: 30,
                      margin: 10,
                    }}
                  >
                    <label className="mr-2" style={{ whiteSpace: 'nowrap' }}>{t("common.subCampaign")}: </label>
                    <div className="select" style={{ flexGrow: 2 }}>
                      <select
                        ref={subCampaingRef}
                        className="select-nesting select-report"
                        style={{ flexGrow: 2, fontSize: 12, backgroundPositionX: "98%", width: 158 }}
                        onChange={(e) => {
                          setCurrentSubCampaign(e.target.value);
                          syncPendingFlag();
                        }}
                      >
                        <option value="All">{t("common.all")}</option>
                        {subCampaings.map((item, i) => (
                          <option key={i} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className='ml-1 mt-2'>
                    {/* == CHECKBOX detailedImprovements == */}
                    <div className="flex flex-row items-center">

                      <div className="m-1">
                        <img
                          id="detailedReport-enable-tooltip"
                          src="/icons/tooltip-indicator-icon.svg"
                          className="cursor-pointer tooltip-nesting"
                          style={{ width: 16, height: 16 }}
                          alt=""
                        />
                        <Tooltip
                          anchorSelect="#detailedReport-enable-tooltip"
                          html={t("reports.detailedReportEnableTooltip")}
                          place="top"
                        />
                      </div>

                      <label style={{ color: "#575756", marginRight: 10 }}>
                        {t("common.detailedImprovements") || "Detailed Improvements Report"}:
                      </label>

                      <div className='pl-3'>
                        <CheckBox2
                          onChange={(e) => {
                            setDetailedImprovements(e.target.checked);
                            syncPendingFlag({ detailedImprovements: e.target.checked });
                          }}
                          default={false}
                          id="ck-detailed-improvements"
                          text=""
                        />
                      </div>

                    </div>

                    {/* == GENERATE EVALUATIONS == */}
                    {(role == 1 || role == 6) &&
                      currentCampaign !== 'All' &&
                      currentSubCampaign !== 'All' && (
                        <button
                          style={{ marginTop: 12, alignItems: 'center', justifyContent: 'center' }}
                          type="button" className='d-flex flex-row mt-3 w-100 bg-white p-2'
                          onClick={() => generateEvaluations()}
                        >
                          <img
                            src="/icons/generate-report.png"
                            style={{ width: 22 }}
                            alt=""
                          />
                          <div className="ml-3 label-report">{t("reports.generateReport")}</div>
                        </button>
                      )}
                  </div>

                </div>

                <div className='mr-2'>
                  {/* == SEARCH PROJECT == */}
                  <div
                    className="filter-reports ml-3 bg-white d-flex flex-row align-items-center justify-space-between"
                    style={{
                      borderRadius: 20,
                      backgroundColor: "white",
                      width: 200,
                      border: "1px solid #4D4D4D",
                      height: 30,
                      margin: 10,
                    }}
                  >
                    <input
                      ref={search_ref}
                      type="text"
                      placeholder={t("menu.searchProject")}
                      className="p-2 home-search"
                      style={{ border: "none", marginLeft: 7, maxWidth: 160 }}
                      onChange={() => syncPendingFlag()}
                    />
                    <div className="p-1 pr-5 mt-1">
                      <img src="/icons/search.svg" style={{ width: 16 }} alt="" />
                    </div>
                  </div>

                  <div>
                    {/* == SEARCH USER == */}
                    <div
                      className="filter-reports ml-3 bg-white d-flex flex-row align-items-center justify-space-between"
                      style={{
                        borderRadius: 20,
                        backgroundColor: "white",
                        width: 200,
                        border: "1px solid #4D4D4D",
                        height: 30,
                        margin: 10,
                      }}
                    >
                      <input
                        ref={search_user}
                        type="text"
                        placeholder={t("menu.searchUser")}
                        className="p-2 home-search"
                        style={{ border: "none", marginLeft: 7, maxWidth: 160 }}
                        onChange={() => syncPendingFlag()}
                      />
                      <div className="p-1 pr-5 mt-1">
                        <img src="/icons/search.svg" style={{ width: 16 }} alt="" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className='mr-2'>
                  {/* == FECHA FROM == */}
                  <div className="filter-reports flex flex-row items-center">
                    <label className="mr-2">{t("common.from")}:</label>
                    <input
                      id="from"
                      ref={from}
                      type="date"
                      className="input-nesting input-date input-date-nesting"
                      onChange={() => {
                        enforceOneYearRule("from");
                        syncPendingFlag();
                      }}
                    />
                  </div>

                  {/* == FECHA TO == */}
                  <div className="filter-reports flex flex-row items-center mt-4">
                    <label className="mr-2">{t("common.to")}:</label>
                    <input
                      ref={to}
                      type="date"
                      className="input-nesting input-date input-date-nesting"
                      onChange={() => {
                        enforceOneYearRule("to");
                        syncPendingFlag();
                      }}
                    />
                  </div>
                </div>

                <div className='mr-2'>
                  {/* == SEARCH WAVE == */}
                  <div
                    className="filter-reports bg-white d-flex flex-row align-items-center justify-space-between"
                    style={{
                      borderRadius: 20,
                      backgroundColor: "white",
                      width: 200,
                      border: "1px solid #4D4D4D",
                      height: 30,
                    }}
                  >
                    <input
                      ref={search_wave}
                      type="text"
                      placeholder={t("menu.searchWave")}
                      className="p-2 home-search"
                      style={{ border: "none", marginLeft: 7, maxWidth: 160 }}
                      onChange={() => syncPendingFlag()}
                    />
                    <div className="p-1 pr-5 mt-1">
                      <img src="/icons/search.svg" style={{ width: 16 }} alt="" />
                    </div>
                  </div>

                  {/* == CHECKBOX excludeShort == */}
                  <div className="flex flex-row items-center mt-5">
                    <label style={{ color: "#575756", marginRight: 10 }}>
                      {t("common.excludeShortCalls")}:
                    </label>

                    <div className='pl-5'>
                      <CheckBox2
                        onChange={(e) => {
                          setExcludeShortConversations(e.target.checked);
                          syncPendingFlag({ excludeShortConversations: e.target.checked });
                        }}
                        default={false}
                        id="ck-short-conversation"
                        text=""
                      />
                    </div>

                  </div>

                </div>



              </div>

            </div>

            {/* === LISTADO DE REPORTES + PAGINACIÓN === */}
            <div
              className="w-full flex flex-row details-project mt-1"
              style={{ backgroundColor: "#F7F7F7", overflowX: "scroll" }}
            >
              <div id="panel-infinity" className="body w-full content-infinity">

                <ListReport
                  id="table-report"
                  openReport={openModalRep}
                  openCallReport={openModalCallRep}
                  downloadPDF={downloadReportPDF}
                  listCall={call_list}
                  search={search}
                  pagination={pagination}
                />

                {/* PAGINACIÓN */}
                <div
                  className="pagination-controls"
                  style={{
                    fontSize: 12,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button onClick={() => goToPage(1)} className="m-1 buttonE buttonH">
                    « {t("common.first")}
                  </button>

                  <button
                    onClick={goPrev}
                    disabled={pagingBusy || pagination.page <= 1}
                    className="m-1 buttonE buttonH"
                  >
                    ‹ {t("common.prev")}
                  </button>

                  <span className="m-1">
                    {t("common.page")} {pagination.page} / {pagination.total_page}
                  </span>

                  <button className="buttonE buttonH m-1" onClick={goNext}>
                    {t("common.next")} ›
                  </button>

                  <button
                    className="buttonE buttonH m-1"
                    onClick={() => goToPage(pagination.total_page)}
                  >
                    {t("common.last")} »
                  </button>
                </div>
              </div>
            </div>


          </div>
        </section>

        {modalRep ?
          <ModalVw clases="bg-[#00000061]" id="repgeneral-modal" visible={modalRep}  >
            <ModalContent styles={{ height: "92%", width: '80%' }} clases={`bg- sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[80%] 2xl:w-1/3  w-[80%]  sm:h-[80%] md:h-[80%] lg:h-[80%] xl:h-[80%]  h-[92%] bg-white`}>
              <ModalHeader title="" onClose={() => closeModalVw("#repgeneral-modal", () => setModalRep(false))} />
              <ModalBody clases={`w-full`} >
                <Report project={project} onClose={() => closeModalVw("#repgeneral-modal", () => setModalRep(false))} />
              </ModalBody>
            </ModalContent>
          </ModalVw> : null}


        {modalCallRep ?
          <ModalVw style={{ backgroundColor: '#00000061' }} className="bg-[#00000061] pt-1" id="reportcall-modal" visible={modalCallRep}  >
            <ModalContent styles={{ overflow: 'hidden', width: '95%' }} clases={` cont-report-md sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  sm:h-[90%] md:h-[90%] lg:h-[90%] xl:h-[95%]  h-[92%]  `}>
              <ModalHeader title="" onClose={() => closeModalVw("#reportcall-modal", () => setModalCallRep(false))} />
              <ModalBody clases={``} styles={{ width: "98%", }} >
                <ReportCall data={call} onClose={() => closeModalVw("#reportcall-modal", () => setModalCallRep(false))}
                  onUpdate={(newQualification) => {
                    updateQualification(call.id, newQualification);
                  }}
                />
              </ModalBody>
            </ModalContent>
          </ModalVw> : null}

        {isRenderingPDF && pdfReportData && (
          <div
            style={{
              position: 'absolute',
              top: '-9999px',
              left: '-9999px',
              width: '1100px',
              background: 'white'
            }}
          >
            <div id="report-pdf-container">
              <CallReportResumePDF data={pdfReportData} onLoadComplete={() => { }} />
            </div>
          </div>
        )}
      </div>
    </>
  )
}
